import type { Event } from '@/lib/Logger/types/Event';

export const HomeDrawerVisibleEvent = (): Event => ({
  name: 'home_drawer_visible',
});
